import React from 'react';
import styled from 'styled-components';
import { ListItemText } from '@mui/material';
import Checkbox from '../../Checkbox/Checkbox';
import MenuItemStyled from '../../DropDown/shared/MenuItemStyled';

const MenuItemWrapper = styled.div`
  padding-left: 4px;
  padding-right: 4px;
`;

const SelectAllMenuItem = styled(MenuItemStyled)`
  margin-top: 4px;
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
`;

const SelectAllText = styled(ListItemText)`
  padding-right: 8px;
`;

interface SelectAllItemProps {
  checked: boolean;
  indeterminate: boolean;
  multiple?: boolean;
  disabled: boolean;
  onClick: () => void;
}

const SelectAllItem = ({
  checked,
  indeterminate,
  multiple,
  disabled,
  onClick,
}: SelectAllItemProps) => {
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <MenuItemWrapper>
      <SelectAllMenuItem
        value="all"
        $multiple={multiple}
        onClick={handleClick}
        selected={checked}
        disabled={disabled}
      >
        <Checkbox checked={checked} indeterminate={indeterminate} />
        <SelectAllText primary="Select all" />
      </SelectAllMenuItem>
    </MenuItemWrapper>
  );
};

export default SelectAllItem;
